import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const creatorReviewsApiService = createApi({
  reducerPath: "creatorReviewsApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getAllCreatorReviews: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `creator-review/course/review-list${query}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetAllCreatorReviewsQuery } = creatorReviewsApiService;
